import React, { useState, useEffect, useRef } from 'react'
import './tickets.css'
import { useParams } from 'react-router-dom'
import { useNavigate } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faUpload } from '@fortawesome/free-solid-svg-icons'
import CarInspectionInterface from '../custom-component/CarInspectionInterface'
import axios from 'axios'
import { ImSpinner2 } from 'react-icons/im'

const SurveyStatus = () => {
  const [selectedMode, setSelectedMode] = useState('')
  const { claimNumber } = useParams()
  const registrationNumber = claimNumber
  const navigate = useNavigate()
  const [modes, setModes] = useState([])
  const [showCarInspection, setShowCarInspection] = useState(false)
  const [currentSectionIndex, setCurrentSectionIndex] = useState(0)
  const [allSections, setAllSections] = useState([])
  const [isMobileView, setIsMobileView] = useState(false)
  const [additionalImages, setAdditionalImages] = useState([])
  const [forceUpdate, setForceUpdate] = useState(0)
  const [loading, setLoading] = useState(true) // Start with loading true
  const [hasCameraOpened, setHasCameraOpened] = useState(false)

  // Camera captured images storage
  const [cameraCapturedImages, setCameraCapturedImages] = useState({})
  const MAX_CAMERA_IMAGES = 6

  // Create refs
  const fileInputRef = useRef(null)

  // Document upload states
  const [uploadingDocIds, setUploadingDocIds] = useState([])
  const [uploadedDocs, setUploadedDocs] = useState({})
  const [uploadTimes, setUploadTimes] = useState({})
  const [existingImages, setExistingImages] = useState({})

  const uploadIcon = `${process.env.PUBLIC_URL}/claim-landing/upload.png`
  const previewIcon = `${process.env.PUBLIC_URL}/preview.png`
  const ticket = `${process.env.PUBLIC_URL}/ticket.png`

  // Main sections - यहाँ बदलें
  const sections = [
    'Front',
    'Front-Left',
    'Left',
    'Back Left',
    'Back',
    'Back Right',
    'Right',
    'Front-Right',
    'Outer Windshield',
    'Inner Windshield',
    'Odometer',
    'Chassis',
    'Engine', 
    'RC'
  ]

  const getDisplayName = (section) => {
    return section === 'Engine' ? 'Engine No.' : section;
  }

  // Check if the screen is mobile size
  useEffect(() => {
    const checkMobileView = () => {
      setIsMobileView(window.innerWidth <= 768)
    }

    checkMobileView()
    window.addEventListener('resize', checkMobileView)

    return () => {
      window.removeEventListener('resize', checkMobileView)
      document.body.style.overflow = ''
      document.body.style.position = ''
      document.body.style.width = ''
      document.body.style.height = ''
    }
  }, [])

  // Fetch mode
  useEffect(() => {
    const fetchMode = async () => {
      try {
        const response = await fetch('/create_audit/get_mode', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ claimNumber: claimNumber })
        })

        const data = await response.json()
        console.log('Mode data:', data)

        if (response.ok) {
          const modeValue = data.mode
          const capitalizedMode =
            modeValue.charAt(0).toUpperCase() + modeValue.slice(1) + ' Mode'
          setModes([capitalizedMode])
          setSelectedMode(capitalizedMode)
        } else {
          console.error('Error fetching mode:', data)
        }
      } catch (error) {
        console.error('Fetch mode error:', error)
      }
    }

    if (claimNumber) {
      fetchMode()
    }
  }, [claimNumber])

  const [isClaimProcessed, setIsClaimProcessed] = useState(false)

  useEffect(() => {
    const fetchStatus = async () => {
      try {
        const res = await axios.post('/process_data/check_annotation_status', {
          claim_id: claimNumber
        })

        console.log('Annotation Status:', res.data, res.data?.is_processed)

        setIsClaimProcessed(res.data?.is_processed === 'processed')
      } catch (err) {
        console.error('Error fetching annotation status:', err)
      }
    }

    fetchStatus()
  }, [claimNumber])

  const formatSectionName = section => {
    return section.toLowerCase().replace(/[\s-]/g, '_').replace(/_+/g, '_')
  }

  // Fixed: Correct file name for backend
  const getImageFileName = (section, index) => {
    let formatted = formatSectionName(section)

    // Handle additional images
    if (section.includes('Additional')) {
      // Extract number from "Additional Image X"
      const numMatch = section.match(/Additional Image (\d+)/)
      const num = numMatch ? numMatch[1] : '1'
      formatted = `additional_image_${num}`
    } else if (section === 'Registration Plate') {
      formatted = 'registrationNo'
    } else if (section === 'RC') {
      formatted = 'RC'
    } else if (index < 8) {
      formatted = `${formatted}_side`
    }

    const imageName = `${registrationNumber}_${formatted}_captured_image.jpeg`
    return imageName
  }

  // Fixed: Check image existence
  const checkImageExists = async (section, index) => {
    try {
      const fileName = getImageFileName(section, index)
      const blobName = `claimImages/${fileName}`

      const response = await axios.post('/process_data/check_document_exists', {
        blobName: blobName
      })

      return {
        exists: response.data.exists,
        url: response.data.exists ? response.data.url : null
      }
    } catch (error) {
      console.error(`Error checking image for ${section}:`, error)
      return { exists: false, url: null }
    }
  }

  // Fixed: Get image URL
  const getImageURL = (section, index) => {
    return new Promise(async resolve => {
      try {
        const result = await checkImageExists(section, index)
        resolve(result.url)
      } catch (error) {
        console.error(`Error getting URL for ${section}:`, error)
        resolve(null)
      }
    })
  }

  // NEW: Load existing additional images
  const loadExistingAdditionalImages = async () => {
    try {
      const newAdditionalImages = []
      const newCameraImages = {}

      for (let i = 1; i <= 6; i++) {
        const sectionName = `Additional Image ${i}`
        const result = await checkImageExists(sectionName, i)

        if (result.exists) {
          newAdditionalImages.push(sectionName)
          newCameraImages[sectionName] = result.url
        }
      }

      if (newAdditionalImages.length > 0) {
        setAdditionalImages(newAdditionalImages)
        setCameraCapturedImages(prev => ({ ...prev, ...newCameraImages }))
        // Mark camera as opened if additional images exist
        if (newAdditionalImages.length > 0) {
          setHasCameraOpened(true)
        }
      }

      return newAdditionalImages
    } catch (error) {
      console.error('Error loading existing additional images:', error)
      return []
    }
  }

  // NEW: Load everything in one go
  const loadAllData = async () => {
    try {
      setLoading(true)

      // Step 1: Load existing additional images
      const existingAdditional = await loadExistingAdditionalImages()

      // Step 2: Combine all sections
      const allSectionsToCheck = [...sections, ...existingAdditional]

      // Step 3: Check all images
      const checkPromises = allSectionsToCheck.map(async (section, i) => {
        const result = await checkImageExists(section, i)
        return { section, exists: result.exists, url: result.url }
      })

      const results = await Promise.all(checkPromises)

      // Step 4: Create status map
      const statusMap = {}
      results.forEach(({ section, exists, url }) => {
        statusMap[section] = exists ? url : null
      })

      // Step 5: Add camera captured images
      Object.keys(cameraCapturedImages).forEach(section => {
        statusMap[section] = cameraCapturedImages[section]
      })

      // Step 6: Add uploaded docs
      Object.keys(uploadedDocs).forEach(docId => {
        const section =
          sections.find(s => formatSectionName(s) === docId) ||
          existingAdditional.find(s => formatSectionName(s) === docId)
        if (section) {
          statusMap[section] = uploadedDocs[docId]
        }
      })

      // Step 7: Update all states
      setExistingImages(statusMap)
      setAllSections(allSectionsToCheck)

      console.log('All data loaded successfully')
    } catch (error) {
      console.error('Error loading all data:', error)
    } finally {
      setLoading(false)
    }
  }

  // Load everything on component mount
  useEffect(() => {
    if (claimNumber) {
      loadAllData()
    }
  }, [claimNumber])

  // Handle camera return
  useEffect(() => {
    const handleCameraReturn = () => {
      if (
        window.capturedCameraPhotos &&
        Array.isArray(window.capturedCameraPhotos)
      ) {
        console.log(
          'Camera returned photos:',
          window.capturedCameraPhotos.length
        )

        const newImages = window.capturedCameraPhotos.slice(
          0,
          MAX_CAMERA_IMAGES
        )
        const newAdditionalImagesList = []
        const newCameraImagesMap = {}

        newImages.forEach((img, i) => {
          const sectionName = `Additional Image ${i + 1}`
          newAdditionalImagesList.push(sectionName)
          newCameraImagesMap[sectionName] = img
        })

        // Update states
        setCameraCapturedImages(newCameraImagesMap)
        setAdditionalImages(newAdditionalImagesList)

        // Mark camera as opened
        if (newImages.length > 0) {
          setHasCameraOpened(true)
        }

        // Reload all data
        loadAllData()

        // Cleanup
        delete window.capturedCameraPhotos
      }
    }

    handleCameraReturn()
  }, [])

  // Fixed: Open CarInspectionInterface
  const openCarInspection = index => {
    setCurrentSectionIndex(index)
    setShowCarInspection(true)

    document.body.style.overflow = 'hidden'
    document.body.style.position = 'fixed'
    document.body.style.width = '100%'
    document.body.style.height = '100%'
  }

  const closeCarInspection = () => {
    setShowCarInspection(false)

    document.body.style.overflow = ''
    document.body.style.position = ''
    document.body.style.width = ''
    document.body.style.height = ''
  }

  const navigateToNextSection = () => {
    if (currentSectionIndex < allSections.length - 1) {
      setCurrentSectionIndex(currentSectionIndex + 1)
    }
  }

  const navigateToPrevSection = () => {
    if (currentSectionIndex > 0) {
      setCurrentSectionIndex(currentSectionIndex - 1)
    }
  }

  // File upload handler
  const handleFileUpload = (event, docId) => {
    const file = event.target.files[0]
    if (!file) return

    const reader = new FileReader()

    reader.onloadend = async () => {
      const fileExtension = file.name.split('.').pop()
      const contentType = file.type

      const fileName = `${claimNumber}_${docId}.${fileExtension}`
      const blobName = `auditImages/${fileName}`

      const base64String = reader.result.split(',')[1]

      try {
        setUploadingDocIds(prev => [...prev, docId])

        const response = await axios.post('/process_data/upload-file', {
          blobName,
          fileContent: base64String,
          contentType
        })

        if (response.status === 200 || response.status === 201) {
          const uploadedUrl = response.data.url

          setUploadedDocs(prev => ({ ...prev, [docId]: uploadedUrl }))
          setExistingImages(prev => ({ ...prev, [docId]: uploadedUrl }))

          // Reload all data after upload
          setTimeout(() => {
            loadAllData()
          }, 500)
        } else {
          console.error('Upload failed with status:', response.status)
        }
      } catch (error) {
        console.error(
          'Error uploading file:',
          error.response?.data || error.message
        )
      } finally {
        setUploadingDocIds(prev => prev.filter(id => id !== docId))
      }
    }

    reader.readAsDataURL(file)
  }

  // Handle file upload for additional images
  const handleAdditionalImageUpload = e => {
    if (!isMobileView) return

    const file = e.target.files[0]
    if (!file) return

    const newPartNumber = additionalImages.length + 1
    if (newPartNumber > MAX_CAMERA_IMAGES) {
      alert(`Maximum ${MAX_CAMERA_IMAGES} additional images allowed`)
      return
    }

    const newSection = `Additional Image ${newPartNumber}`
    const formattedId = formatSectionName(newSection)

    setAdditionalImages(prev => [...prev, newSection])

    // Upload the image
    const customEvent = {
      target: {
        files: [file]
      }
    }
    handleFileUpload(customEvent, formattedId)
  }

  const openFileDialog = () => {
    if (!isMobileView) {
      alert('Upload feature is only available on mobile devices.')
      return
    }

    if (hasCameraOpened) {
      alert('Camera has already been used. Cannot upload additional images.')
      return
    }

    fileInputRef.current.click()
  }

  // Camera for additional images
  const openCameraForAdditionalImages = () => {
    if (hasCameraOpened) {
      alert('Camera has already been used. Cannot capture more images.')
      return
    }

    if (additionalImages.length >= MAX_CAMERA_IMAGES) {
      alert(`You can capture maximum ${MAX_CAMERA_IMAGES} images only.`)
      return
    }

    navigate(`/audit/photoretake/permission/${claimNumber}`, {
      state: {
        maxImages: MAX_CAMERA_IMAGES,
        existingCount: additionalImages.length
      }
    })
  }
  useEffect(() => {
    const handlePopState = () => {
      navigate(`/claimlanding/${claimNumber}`, { replace: true })
    }

    window.addEventListener('popstate', handlePopState)
    return () => window.removeEventListener('popstate', handlePopState)
  }, [navigate, claimNumber])

  // Added: Missing function for desktop view
  const handleAdditionalImageClick = () => {
    if (!isMobileView) {
      openFileDialog()
    }
  }

  // Check if section has image available
  const isSectionAvailable = section => {
    return existingImages[section] || uploadedDocs[formatSectionName(section)]
  }

  // Check if button should be disabled
  const isUploadButtonDisabled = () => {
    return hasCameraOpened || additionalImages.length >= MAX_CAMERA_IMAGES
  }

  // Get button text based on state
  const getUploadButtonText = () => {
    if (hasCameraOpened) {
      return 'Upload additional Images'
    } else if (additionalImages.length >= MAX_CAMERA_IMAGES) {
      return `Maximum ${MAX_CAMERA_IMAGES} Images Uploaded`
    } else {
      return `Upload Additional Images (${additionalImages.length}/${MAX_CAMERA_IMAGES})`
    }
  }

  return (
    <div className='survey-wrapper'>
      {loading && (
        <div className='loading-overlay-ticket'>
          <ImSpinner2 className='spinner' />
          <span>Loading all images...</span>
        </div>
      )}

      {/* Main Content - Show only when NOT loading */}
      {!loading && (
        <>
          {/* CarInspectionInterface Show Conditionally */}
          {showCarInspection ? (
            <CarInspectionInterface
              currentIndex={currentSectionIndex}
              sections={allSections}
              registrationNumber={registrationNumber}
              onClose={closeCarInspection}
              onNext={navigateToNextSection}
              onPrev={navigateToPrevSection}
              getImageURL={getImageURL}
              existingImages={existingImages}
              uploadedImages={uploadedDocs}
            />
          ) : (
            <>
              {/* Main Survey Container */}
              <div className='survey-container'>
                <div className='survey-header'>
                  <div className='survey-title'>
                    <img
                      src={ticket}
                      alt='Company Logo'
                      className='survey-logo'
                    />
                    <span>Survey Status</span>
                  </div>
                </div>

                <div className='survey-modes'>
                  {modes &&
                    modes.map(mode => (
                      <span
                        key={mode}
                        className={`mode ${
                          selectedMode === mode ? 'active' : ''
                        }`}
                        onClick={() => setSelectedMode(mode)}
                      >
                        {mode}
                      </span>
                    ))}
                </div>

                <div className='survey-sections'>
                  {sections.map((section, index) => {
                    const isAvailable = isSectionAvailable(section)

                    return (
                      <div key={section} className='survey-item'>
                        <span>{getDisplayName(section)}</span> 
                        <div className='icon-wrapper'>
                          <button
                            className={`preview-button-claim ${
                              isAvailable ? 'available' : 'unavailable'
                            }`}
                            onClick={() =>
                              isAvailable && openCarInspection(index)
                            }
                            disabled={!isAvailable}
                          >
                            <img
                              src={previewIcon}
                              alt='Preview Icon'
                              className='preview-icon'
                            />
                            <span className='preview-text'>Preview</span>
                          </button>
                        </div>
                      </div>
                    )
                  })}
                </div>
              </div>

              {/* Additional Images Container - Show if images exist */}
              {(additionalImages.length > 0 ||
                Object.keys(cameraCapturedImages).length > 0) && (
                <div className='additional-container'>
                  <h1>Additional Images</h1>
                  <div className='additional-sections'>
                    {additionalImages.map((section, index) => {
                      const hasImage =
                        existingImages[section] ||
                        cameraCapturedImages[section] ||
                        uploadedDocs[formatSectionName(section)]

                      return (
                        <div key={section} className='survey-item'>
                          <span>{getDisplayName(section)}</span> 
                          <div className='icon-wrapper'>
                            <button
                              className={`preview-button-claim ${
                                hasImage ? 'available' : 'unavailable'
                              }`}
                              disabled={!hasImage}
                              onClick={() =>
                                hasImage &&
                                openCarInspection(sections.length + index)
                              }
                            >
                              <img
                                src={previewIcon}
                                alt='Preview Icon'
                                className='preview-icon'
                              />
                              <span className='preview-text'>Preview</span>
                            </button>
                          </div>
                        </div>
                      )
                    })}
                  </div>
                </div>
              )}

              {/* Hidden file input for additional images */}
              <input
                type='file'
                accept='image/*'
                ref={fileInputRef}
                style={{ display: 'none' }}
                onChange={handleAdditionalImageUpload}
                disabled={isUploadButtonDisabled()}
              />

              {/* Upload Additional Images Button */}
              {!isClaimProcessed && !isUploadButtonDisabled() && (
                <button
                  className='upload-additional-images'
                  onClick={
                    isMobileView
                      ? openCameraForAdditionalImages
                      : handleAdditionalImageClick
                  }
                  disabled={isUploadButtonDisabled()}
                >
                  <FontAwesomeIcon icon={faUpload} />
                  {getUploadButtonText()}
                </button>
              )}
            </>
          )}
        </>
      )}
    </div>
  )
}

export default SurveyStatus